/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { FC, ReactNode } from "react";
import CloseButton from "views/Mission/TeamSpecV2/components/CloseButton";
import { globalStyleClasses } from "views/Mission/TeamSpecV2/globalStyles";
import { useCSSRulesWithTheme } from "hooks/useCSSRulesWithTheme";
import { noop } from "lodash";

const GenericModal: FC<{
  isOpen: boolean;
  onClose: () => void;
  trackingName: string;
  children: ReactNode;
  showCloseButton?: boolean;
  showGradient?: boolean;
  overlayClickable?: boolean;
  className?: string;
}> = ({
  children,
  isOpen,
  onClose,
  showCloseButton = true,
  trackingName = "generic",
  showGradient = true,
  overlayClickable = true,
  className,
}) => {
  const globalStyles = useCSSRulesWithTheme(globalStyleClasses, {
    modalIsOpen: isOpen,
    overlayClickable,
  });

  return (
    <div css={globalStyles.modalContainer}>
      <div
        onClick={() => (overlayClickable ? onClose() : noop)}
        css={css(globalStyles.modalOverlay)}
      />
      <div css={css(globalStyles.modal, className)}>
        {showGradient && <div css={globalStyles.modalGradient} />}
        {children}
        {showCloseButton && (
          <CloseButton
            css={globalStyles.closeButton}
            name={`Close ${trackingName} modal`}
            onClick={onClose}
          />
        )}
      </div>
    </div>
  );
};

export default GenericModal;
